export enum EventIds{
    kioskConnectedToMeeting = 1000,
    kioskInLobby = 1004,
    kioskDisconnectedFromMeeting = 1001,
    partnerConnectedToMeeting = 1002,
    partnerDisconnectedFromMeeting = 1003,
    print = 2000,
    scan = 2001,
    navigateToWebsite = 3000
}